import {
  EARN_DETAILS_STATE,
  EarnEmbeddedDetailsData,
  UseEarnDetailsDataHandlers,
} from '../../types/detailsState'
import { formatAPY, toEarnCustomerAmountsView, toEarnTotalEarningsView } from '../../utils/utils'
import { useEarnDetailsBaseData } from './useEarnDetailsBaseData'

export const useEarnEmbeddedDetailsData = (
  portfolioId: string | undefined,
  handlers: UseEarnDetailsDataHandlers
): EarnEmbeddedDetailsData => {
  const baseData = useEarnDetailsBaseData(portfolioId, handlers)

  if (baseData.detailsState !== EARN_DETAILS_STATE.READY) {
    return baseData
  }

  const { details, merchantStatistics, ...viewData } = baseData

  return {
    ...viewData,
    epcTakesEarn: details.epcTakesEarn,
    customerEarnRate: formatAPY(details.customerEarnRate ?? 0),
    totalEarnings: toEarnTotalEarningsView(details.totalEarnings),
    customerSummary: toEarnCustomerAmountsView(merchantStatistics),
  }
}
